import { render } from "./DiarioClasse.vue?vue&type=template&id=1802b5e1&ts=true"
import script from "./DiarioClasse.vue?vue&type=script&lang=ts"
export * from "./DiarioClasse.vue?vue&type=script&lang=ts"

import "./DiarioClasse.vue?vue&type=style&index=0&id=1802b5e1&lang=css"

import exportComponent from "/Users/diogooliveira/Documents/workspace_personal/aureo/aureov2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QImg});
